class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.trendingSearchesContainer = this.closest('search-modal')?.querySelector('.search__trending');

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
          this.toggleTrendingSearches();
        }, 300).bind(this),
      );

      if (this.input.parentElement.querySelector(".search__input--icon-clear") != null) {
        let clearIcon = this.input.parentElement.querySelector(".search__input--icon-clear");

        clearIcon.addEventListener('click', () => {
          this.input.form.reset();
          this.onFormReset();
          this.toggleTrendingSearches();
        });
      }
    }

    this.setupTrendingSearches();
    this.toggleTrendingSearches();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    if (event) {
      event.preventDefault();
    }
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = "";
      //this.input.focus();
    }
    this.toggleTrendingSearches();
  }

  setupTrendingSearches() {
    const searchModal = this.closest('search-modal') || document.querySelector('search-modal');
    if (!searchModal) return;

    const trendingLinks = searchModal.querySelectorAll('.search__trending-link');

    for (const link of trendingLinks) {
      if (link.hasAttribute('data-trending-initialized')) continue;
      link.setAttribute('data-trending-initialized', 'true');

      link.addEventListener('click', (event) => {
        event.preventDefault();
        const searchTerm = link.getAttribute('data-trending-search');

        if (!searchTerm) return;

        const searchInput = searchModal.querySelector('input[type="search"]');
        if (searchInput) {
          searchInput.value = searchTerm;
          searchInput.focus();

          const inputEvent = new Event('input', { bubbles: true });
          searchInput.dispatchEvent(inputEvent);
          this.toggleTrendingSearches();
        }
      });
    }
  }

  toggleTrendingSearches() {
    if (this.trendingSearchesContainer) {
      if (this.input && this.input.value.trim().length > 0) {
        this.trendingSearchesContainer.classList.add('search__trending--hidden');
      } else {
        this.trendingSearchesContainer.classList.remove('search__trending--hidden');
      }
    }
  }
}

customElements.define("search-form", SearchForm);
